import { injectGlobal } from 'emotion'
import {
  mediaQueries,
  mediaQueryNames
} from '../components/shared/ui/variables'

/**
 * Generates css to the body::after content tag
 * so the HOC appliedMediaQuery can return the media query
 * applied by the css.
 * Makes easier to get the applied media query in javascript and
 * use the same variables from js or css.
 * @constructor
 * @param {Array<string>} mediaQueries - Array of media queries
 * @param {Array<string>} names - Names for the array of media queries.
 */

const insertCssToBody = (mediaQueries: string[], names: string[]) => {
  // insert style with no media query
  injectGlobal(`body::after { display: none}`)
  injectGlobal(`body::after { content: "0:${names[0]}"}`)
  // loop mediaQueries to create mediaQuery elements
  mediaQueries.forEach((media, index) => {
    injectGlobal(
      `${media} { body::after { content: "${index + 1}:${names[index + 1]}"} }`
    )
  })
}

insertCssToBody(mediaQueries, mediaQueryNames)
